import { wasmModule } from "../wasm/wasmModule"

class StagingIPRModule {
  private isOpen = false

  switchStagingIPRModule(isOpen: boolean) {
    if (!wasmModule.isFinishedOpencase) return
    console.log("switchStagingIPRModule", isOpen)
    wasmModule.moduleManager.SwitchModuleStagingIPR(isOpen)
  }

  addNewIPRNode(archType: number, stageIndex: number) {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    if (iprModule == null) return false
    return iprModule.AddNewIPRNode(archType, stageIndex)
  }

  removeIPRNode(archType: number, stageIndex: number) {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    if (iprModule == null) return
    iprModule.RemoveIPRNode(archType, stageIndex)
  }

  moveIPRNode(archType: number, orgStageIndex: number, tarStageIndex: number) {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    if (iprModule == null) return
    iprModule.MoveIPRNode(archType, orgStageIndex, tarStageIndex)
  }

  getCollisionStage(archType: number) {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    if (iprModule == null) return 0
    const str = iprModule.GetCollisionStage(archType)
    const nums: number[] = str.split(';').map(Number)
    return nums
  }

  checkRemainingIPR(): string {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    if (iprModule == null) return ""
    const str = iprModule.CheckRemainingIPR()
    return str
  }

  checkNullIPRNodes() {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    let res = {
      archType: -1,
      stage: -1,
      info: ""
    }
    if (iprModule == null) return res
    const resStr = iprModule.CheckNullIPRNodes()
    if (resStr != "")
    {
      const str: string[] = resStr.split(';')
      res.archType = Number(str[0])
      res.stage = Number(str[1])
      res.info = str[2]
    }
    return res
  }

  removeNullIprNodes() {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    if (iprModule == null) return
    iprModule.RemoveNullIprNodes()
  }

  setNumberingSys(numberingSys: string) {
    const iprModule = wasmModule.moduleManager.GetModuleStagingIPR()
    if (iprModule == null) return
    iprModule.SetNumberingSys(numberingSys)
  }
}

export const stagingIPRModule = new StagingIPRModule()